import { Component } from "react";
import './Header.css';
import Logo from '../images/logo.png';
import Button from 'react-bootstrap/Button';

class Header extends Component{
    render(){
        return(
            <div className="Header container-fluid" id="header">
                <div>
                    <img className="logo" src={Logo} alt="ANA IT Logo" />
                    <h3 className="title">Technology Consulting Company</h3>
                </div>
                <Button className="btn_contact" href="#contact-us">Contact Us</Button> {/* Call to action button that will scroll directly to the Contact Form at the bottom of the page */}
                
            </div>
        );
    }
}

export default Header;